// extracted by mini-css-extract-plugin
export var callCard = "_rm-0";
export var callMessageButton = "_rm-1";
export var helpIcon = "_rm-3";
export var helpIconContainer = "_rm-4";
export var verticalDivider = "_rm-2";